import { ENTORNO } from "../utils/constantes";
import { getToken } from "../utils/variablesLocales";

export class apiEmpresa {
  baseApi = ENTORNO.BASE_API;

  async obtener() {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Empresa_ObtenerTodas}`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async actualizar(Id, Nombre, Email, Telefono, Logo, Localidad, Activo) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Empresa_Actualizar}/${Id}`;

      const parametros = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          Nombre: Nombre,
          Email: Email,
          Telefono: Telefono,
          Logo: Logo,
          Localidad: Localidad,
          Activo: Activo,
        }),
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async nuevo(Nombre, Email, Telefono, Logo, Localidad, Activo) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Empresa_Nuevo}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          Nombre: Nombre,
          Email: Email,
          Telefono: Telefono,
          Logo: Logo,
          Localidad: Localidad,
          Activo: Activo,
        }),
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async borrar(Id) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Empresa_Borrar}/${Id}`;

      const parametros = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }
}
